var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultAuthor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49,
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_350_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 48C56.6274 48 62 42.6274 62 36C62 29.3726 56.6274 24 50 24C43.3726 24 38 29.3726 38 36C38 42.6274 43.3726 48 50 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74 76C74 62.7452 63.2548 52 50 52C36.7452 52 26 62.7452 26 76H74Z",
    fill: "url(#paint0_linear_350_14)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_350_14",
    x1: 50,
    y1: 52,
    x2: 50,
    y2: 81.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_350_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 52,
    fill: "white",
    transform: "translate(26 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAuthor);
export default __webpack_public_path__ + "static/media/DefaultAuthor.7dbd0d328fb16b200c8aac0b99f6fd73.svg";
export { ForwardRef as ReactComponent };